import { createRouteContextObject } from '@shared/utils';
import { HttpContextBase } from '..';

enum HttpContextRoutes {
  //Projects
  GetAllProjects,
  GetProjects,
  SyncProjects,

  //Scopes
  GetScopes,
  SyncScopes,

  //Vessels/Locations
  GetVesselLocations,
  SyncVesselLocations,

  //Subprojects
  GetAllSubprojects,
  GetSubprojects,
  SyncSubprojects,
}

export const HttpProjectAdminContext = createRouteContextObject(
  HttpContextBase.ProjectAdmin,
  HttpContextRoutes
);
